import * as XLSX from 'xlsx-js-style'

export const mergeParentHeader = (header) => {
    const mergesHeader = header.reduce((acc, curr, idx) => {
        if (curr === 'PLM Segment Alarms' || curr === 'PLM Station Alarms') {
            acc.push({
                s: { c: 0, r: 3 },
                e: { c: 12, r: 3 }
            })
        }
        if (curr === 'Short') {
            acc.push({
                s: { c: 13, r: 3 },
                e: { c: 18, r: 3 }
            })
        }
        if (curr === 'Over') {
            acc.push({
                s: { c: 19, r: 3 },
                e: { c: 21, r: 3 }
            })
        }
        return acc;
    }, []);
    return mergesHeader
}

export const mergeChildHeader = (worksheet) => {

    // Merge slicers
    worksheet["!merges"].push(XLSX.utils.decode_range("A1:B1"));
    worksheet["!merges"].push(XLSX.utils.decode_range("C1:E1"));
    worksheet["!merges"].push(XLSX.utils.decode_range("F1:F1"));
    worksheet["!merges"].push(XLSX.utils.decode_range("G1:G1"));
    worksheet["!merges"].push(XLSX.utils.decode_range("H1:N1"));

    // Merge 2nd header
    worksheet["!merges"].push(XLSX.utils.decode_range("A5:B5"));
    worksheet["!merges"].push(XLSX.utils.decode_range("C5:E5"));
    worksheet["!merges"].push(XLSX.utils.decode_range("F5:H5"));
    worksheet["!merges"].push(XLSX.utils.decode_range("I5:M5"));

    worksheet["!merges"].push(XLSX.utils.decode_range("X5:Y5"));
    worksheet["!merges"].push(XLSX.utils.decode_range("Z5:AB5"));
    return worksheet
}

export const mergeDataRows = (workSheet, rows) => {
    //A3:B3 = (Column A Row 3):(Column B Row 3)
    if (rows.length) {
        // data display starts from 6th row in excel
        for (let row = 6; row <= (rows.length - 1) + 6; row++) {
            workSheet["!merges"].push(XLSX.utils.decode_range(`A${row}:B${row}`));
            workSheet["!merges"].push(XLSX.utils.decode_range(`C${row}:E${row}`));
            workSheet["!merges"].push(XLSX.utils.decode_range(`F${row}:H${row}`));
            workSheet["!merges"].push(XLSX.utils.decode_range(`I${row}:M${row}`));
            workSheet["!merges"].push(XLSX.utils.decode_range(`X${row}:Y${row}`));
            workSheet["!merges"].push(XLSX.utils.decode_range(`Z${row}:AB${row}`));
        }
    } else {
        workSheet["!merges"].push(XLSX.utils.decode_range("A6:B6"));
        workSheet["!merges"].push(XLSX.utils.decode_range("C6:E6"));
        workSheet["!merges"].push(XLSX.utils.decode_range("F6:H6"));
        workSheet["!merges"].push(XLSX.utils.decode_range("I6:M6"));
        workSheet["!merges"].push(XLSX.utils.decode_range("X6:Y6"));
        workSheet["!merges"].push(XLSX.utils.decode_range("Z6:AB6"));
    }
    return workSheet
}